module.exports = __webpack_public_path__ + "img/avatar-s-24.8232245b.jpg";